export default __webpack_public_path__ + "static/media/banner-vida-senior.fee13929.png";